import React from "react";
import CatalogPageShell from "../components/Products/CatalogPageShell.jsx";
import InvoiceGrid from "../components/Products/InvoiceGrid.jsx";

export default function Invoices() {
    return (
        <CatalogPageShell
            title="Invoices"
            subtitle="Track incoming purchase invoices, mark them received, and review linked catalog totals."
        >
            <InvoiceGrid />
        </CatalogPageShell>
    );
}
